export default class SortColumnModel {
	constructor(
		public readonly columnId: string,
		public readonly sortPath: string,
		public readonly isAsc: boolean
	) { }

	toQueryString() {
		return `${this.sortPath},${this.isAsc ? "asc" : "desc"}`
	}
}